import { FormattedMessage, useIntl } from 'react-intl'
import styled from 'styled-components'

import { WarningIcon } from '@10xLabs/react-web/components/Icons/Warning'
import { FormattedTimeByDate } from '@10xLabs/react-web/components/FormattedTimeByDate'
import { FormattedPrice } from '@10xLabs/react-web/components/FormattedPrice'
import { FormattedDate } from '@10xLabs/react-web/components/FormattedDate'

const Warning = styled.p<TSFixMe>`
  display: flex;
  align-items: center;
  font-size: 22px;
  color: #b71c1c;
  margin: 0 0 20px;
`

const StyledWarningIcon = styled(WarningIcon)<TSFixMe>`
  fill: #b71c1c;
  width: 18px;
  height: 18px;
  margin-right: 10px;
`

const Table = styled.table<TSFixMe>`
  border-collapse: collapse;
  width: 100%;
`

const Th = styled.th<TSFixMe>`
  text-align: left;
  padding: 7px 20px;
`

const Td = styled.td<TSFixMe>`
  padding: 20px;
  background-color: #f8f9fc;
`

export const TotalCancellation = ({ sale }: TSFixMe): TSFixMe => {
  const intl = useIntl()

  return (
    <div>
      <Warning>
        <StyledWarningIcon />

        <FormattedMessage
          id="sale.cancellation.desc.title"
          defaultMessage="¿Estás seguro de cancelar la venta completa?"
        />
      </Warning>

      <div>
        <Table>
          <thead>
            <tr>
              <Th>
                <FormattedMessage id="sale.cancellation.total.date" defaultMessage="Fecha del pago" />
              </Th>

              <Th>
                <FormattedMessage id="sale.cancellation.total.amount" defaultMessage="Total" />
              </Th>
            </tr>
          </thead>

          <tbody>
            <tr>
              <Td>
                <FormattedDate intl={intl} value={sale.createdAt} month="2-digit" day="2-digit" year="numeric" />{' '}
                <FormattedTimeByDate intl={intl} date={sale.createdAt} />
              </Td>

              <Td>
                <FormattedPrice value={sale.payment.amount} />
              </Td>
            </tr>
          </tbody>
        </Table>
      </div>
    </div>
  )
}
